export default "__VITE_ASSET__RVDbQIE$__"